import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';

import { AccountService, AlertService } from '@app/_services';

@Component({
    template: `
        <div class="login-wrapper">
            <div class="login-card">
                <div class="login-header">
                    <img src="assets/AllianceInsuranceWebsite.png" alt="Alliance Assure" class="login-logo">
                    <h2 class="mt-3 mb-1" style="font-weight: 700; color: #1E293B;">Welcome Back</h2>
                    <p class="text-muted mb-0">Sign in to Alliance Assure Portal</p>
                </div>
                <form [formGroup]="form" (ngSubmit)="onSubmit()">
                    <div class="mb-3">
                        <label for="username" class="form-label">Username</label>
                        <input type="text" id="username" formControlName="username" class="form-control"
                               [class.is-invalid]="submitted && f.username.errors"
                               placeholder="Enter your username"
                               aria-describedby="usernameError">
                        <div id="usernameError" class="invalid-feedback" *ngIf="submitted && f.username.errors">
                            <span *ngIf="f.username.errors.required">Username is required</span>
                        </div>
                    </div>
                    <div class="mb-3">
                        <label for="password" class="form-label">Password</label>
                        <input type="password" id="password" formControlName="password" class="form-control"
                               [class.is-invalid]="submitted && f.password.errors"
                               placeholder="Enter your password"
                               aria-describedby="passwordError">
                        <div id="passwordError" class="invalid-feedback" *ngIf="submitted && f.password.errors">
                            <span *ngIf="f.password.errors.required">Password is required</span>
                        </div>
                    </div>
                    <div *ngIf="error" class="alert alert-danger py-2 mb-3" role="alert">
                        <i class="fa fa-exclamation-circle me-1"></i> {{ error }}
                    </div>
                    <button [disabled]="loading" class="btn btn-primary w-100 py-2 mb-3">
                        <span *ngIf="loading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                        Sign In
                    </button>
                </form>
            </div>
        </div>
    `
})
export class LoginComponent implements OnInit {
    form!: UntypedFormGroup;
    loading = false;
    submitted = false;
    error = '';

    constructor(
        private formBuilder: UntypedFormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private accountService: AccountService,
        private alertService: AlertService
    ) { }

    ngOnInit() {
        this.form = this.formBuilder.group({
            username: ['', Validators.required],
            password: ['', Validators.required]
        });
    }

    // convenience getter for easy access to form fields
    get f() { return this.form.controls; }

    onSubmit() {
        this.submitted = true;

        // reset alerts on submit
        this.alertService.clear();

        // stop here if form is invalid
        if (this.form.invalid) {
            return;
        }

        this.loading = true;
        this.error = '';
        this.accountService.login(this.f.username.value, this.f.password.value)
            .pipe(first())
            .subscribe({
                next: () => {
                    // get return url from query parameters or default to home page
                    const returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
                    this.router.navigateByUrl(returnUrl);
                },
                error: error => {
                    this.error = error;
                    this.alertService.error(error);
                    this.loading = false;
                }
            });
    }
}